import { FC, ReactNode } from 'react';
import { Header } from '../header';
import { SideBarWrapper } from './components/SideBarWrapper';
import { SearchFilterWrapper } from './components/SearchFilterWrapper';
import { PrivacyLinksWrapper } from './components/PrivacyLinksWrapper';
import { HelpDeskWrapper } from './components/HelpDeskWrapper';
import './appLayout.scss';

interface Props {
  children: ReactNode;
}

export const AppLayout: FC<Props> = ({ children }) => {
  return (
    <div className='layout-app__inner'>
      <Header />
      <div className='layout-app__wrapper'>
        <div className='layout-app__menu'>
          <SideBarWrapper />
        </div>
        <div className='layout-app__main-area'>
          <SearchFilterWrapper />
          <div className='layout-app__content'>{children}</div>
          <PrivacyLinksWrapper />
        </div>
      </div>
      <HelpDeskWrapper />
    </div>
  );
};
